// extracted by mini-css-extract-plugin
module.exports = {"adContainer":"Ad-modules__adContainer___lXs5q","center":"Ad-modules__center___3_8-p"};